var _defs, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPinFavSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon",
    width: 29.06,
    height: 34.186,
    x: 4.042,
    y: 0.908,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.667,
    d: "M0 0H60V60H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Icon)",
    transform: "scale(1.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dc4405",
    fillRule: "evenodd",
    d: "M4408 8210.461a11.5 11.5 0 00-11.531 11.464c0 8.98 9.369 16.722 11.531 16.722 2.162 0 11.529-7.741 11.529-16.722a11.5 11.5 0 00-11.529-11.464z",
    "data-name": "Icon",
    transform: "translate(-4389.43 -8206.55)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 1.667,
    d: "M30.953 31.615l6.194 3.738-1.645-7.04 5.471-4.74-7.208-.626-2.812-6.634-2.816 6.634-7.205.621 5.461 4.745-1.628 7.04z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinFavSelected);
export default __webpack_public_path__ + "static/media/map_pin_fav-selected.762817338792c03366b6c1836c6e9102.svg";
export { ForwardRef as ReactComponent };